import { css, cx } from '@emotion/css';
import anchorLogotipo from '../../../assets/anchor-brand/anchor-logotipo.svg';
import React from 'react';

export interface LogoTypeProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt'> {
  alt?: string;
}

const typeStyle = css({
  display: 'block',
  height: '100%',
  width: 'auto',
});

export const LogoType = React.forwardRef<HTMLImageElement, LogoTypeProps>(
  ({ className, alt, ...rest }, ref) => {
    return (
      <img
        ref={ref}
        src={anchorLogotipo}
        alt={alt || 'Anchor Ingressos'}
        className={cx(typeStyle, className)}
        {...rest}
      />
    );
  }
);

LogoType.displayName = 'LogoType';

export default LogoType;
